import * as angular from 'angular';
import 'angular-ui-bootstrap';

import onAuthFailed from './authFailed';
import authFailed from './interceptors';
import loginController from './security-controllers';
import security from './security-services';

export interface AuthEvents {
    AUTH_FAILED: string;
    AUTH_CHANGED: string;
    AUTH_LOGGED_IN: string;
    AUTH_LOGGED_OUT: string;
}

export const AUTH_EVENTS: AuthEvents = {
    AUTH_FAILED: 'event:authentication-failure',
    AUTH_CHANGED: 'event:authentication-changed',
    AUTH_LOGGED_IN: 'event:authentication-logged-in',
    AUTH_LOGGED_OUT: 'event:authentication-logged-out'
};

export default angular.module('dataforvalter.security', [
    "ui.bootstrap"
])
    .constant('AUTH_EVENTS', AUTH_EVENTS)
    .config(authFailed)
    .run(onAuthFailed)
    .service('security', security)
    .controller('loginController', loginController)
    .name;
